import React from "react";
import {
  Container,
  Box,
  Divider,
  ListItemText,
  Typography,
  Checkbox,
  MenuItem,
  ListSubheader,
} from "@mui/material";
import Field from "../Field/Fi";
import Button from "../Button/Button";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";
import CheckMarkSelect from "./CheckMarkSelect";

const makeModelData = [
  { text: "All (20,112)" },
  { text: "Caterpillar Inc. (203)" },
  { text: "All", margin: 1, parent: "Caterpillar Inc. (203)" },
  { text: "Cat-bt007 (21)", margin: 1, parent: "Caterpillar Inc. (203)" },
  { text: "Cat-12 (21)", margin: 2, parent: "Cat-bt007 (21)" },
  { text: "Doosan (132)" },
  { text: "Hitachi (22)" },
  { text: "JCB (12)" },
  { text: "Yanmar (33)" },
  { text: "Fiat (11)" },
  { text: "Honda (10)" },
  { text: "Hyundai (22)" },
  { text: "KIA (80)" },
];

export default function MakeModel({
  height,
  disabled,
  sx,
  menuWidth,
  formStyle,
  setYearDisabled,
}) {
  const [modelList, setModelList] = React.useState([]);
  const modelSelectChange = (event) => {
    const {
      target: { value },
    } = event;
    setModelList(
      // On autofill we get a the stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    setYearDisabled(false);
  };
  const showItem = (data) => {
    if (data.parent) {
      return modelList.indexOf(data.parent) > -1;
    } else return true;
  };

  return (
    <CheckMarkSelect
      menuWidth={menuWidth ? "282px" : "auto"}
      height={height}
      formStyle={{
        ...formStyle,
        backgroundColor: modelList.length > 0 && "#255CCE1A",
      }}
      handleChange={modelSelectChange}
      dataList={modelList}
      disabled={disabled}
      label="Make and Model"
      sx={{ width: "100%", ...sx }}
    >
      <MenuItem
        disableRipple={true}
        sx={{
          paddingBottom: "0px !important",
          backgroundColor: "white !important",
        }}
      >
        <Field
          label="Make and Model"
          labelVariant="body2"
          labelFont="14px"
          size="small"
          sx={{
            "& .MuiOutlinedInput-root": {
              padding: "0px",
            },
            width: { sm: "100%", md: "100%" },
            height: "38.14px",
          }}
          endIcon={<SearchIcon sx={{ color: "#808080", marginRight: "8px" }} />}
          borderColor="#BFBFBF"
          labelStyle={{ color: "#616161" }}
          labelColor="#616161"
          // value={val}
          // handleChange={({ target }) => setVal(target.value)}
          transform="translate(7px,7px)"
        ></Field>
        {/* <Field
          label="Make and Model"
          sx={{ width: "100%" }}
          endIcon={<SearchIcon sx={{ color: "#808080" }} />}
          size="small"
          height="38px"
          transform="translate(7px,7px)"
        /> */}
      </MenuItem>
      <ListSubheader sx={{ fontSize: "12px", fontWeight: "400" }}>
        MAKES
      </ListSubheader>
      {makeModelData.map((data, index) =>
        showItem(data) ? (
          <MenuItem
            disableRipple={true}
            key={index}
            value={data.text}
            sx={{
              padding: "0 !important",
              marginBottom: "8px",
              paddingLeft: data.margin
                ? `${20 + data.margin * 28}px !important`
                : "20px !important",
              backgroundColor: "white !important",
              "&:hover": {
                backgroundColor: "rgba(68, 32, 161, 0.08) !important",
              },
            }}
          >
            <Checkbox
              sx={{
                padding: "0px",
                color: "text.primary",
                "& .MuiSvgIcon-root": { fontSize: 18 },
                "&.Mui-checked": {
                  color: "#6200EE",
                },
              }}
              checked={modelList.indexOf(data.text) > -1}
            />
            <ListItemText
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                color:
                  modelList.indexOf(data.text) > -1
                    ? "#6200EE"
                    : "text.primary",
              }}
              primary={data.text}
            />
          </MenuItem>
        ) : null
      )}

      <Divider sx={{ margin: "0px !important" }} />
      <Container
        disableGutters={true}
        sx={{
          display: "flex",
          padding: "15px 16px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            columnGap: "8px",
          }}
        >
          <CheckIcon
            sx={{
              width: "16px",
              height: "16px",
              color: "#616161",
            }}
          />
          <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              lineHeight: "20px",
              color: "#616161",
            }}
          >
            {modelList.length} Selected
          </Typography>
        </Box>
        <Button
          sx={{ padding: "0px", minWidth: "fit-content" }}
          variant="text"
          centerRipple={false}
          onClick={() => {
            console.log("working");
            setYearDisabled(true);
            setModelList([]);
          }}
        >
          Reset
        </Button>
      </Container>
    </CheckMarkSelect>
  );
}
